import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/joy';
import { PageHelpButton } from '../knowledge-base/PageHelpButton';

export function PageHeader({ title, description, section, actions }: {
  title: string; description?: string; section?: string; actions?: ReactNode;
}) {
  return <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 3 }}>
    <Box sx={{ minWidth: 0, flex: '1 1 280px' }}>
      {section && <Typography level="body-xs" sx={{ color: 'text.tertiary', fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', mb: 0.5 }}>{section}</Typography>}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Typography level="h1">{title}</Typography><PageHelpButton /></Box>
      {description && <Typography level="body-sm" sx={{ color: 'text.secondary', mt: 1, maxWidth: '76ch', lineHeight: 1.6 }}>{description}</Typography>}
    </Box>
    {actions && <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>{actions}</Box>}
  </Box>;
}
